import React from 'react';
import { Redirect } from 'react-router-dom';
import { Me } from '../../../types';

type Props = {
  currentNetworkId?: string;
  handleGodModeAccess?(): React.ReactNode;
  children: React.ReactNode;
} & Pick<Me, 'permissions'>;

export function ProtectedNetworkComponent({
  permissions,
  currentNetworkId,
  children,
  handleGodModeAccess = () => <Redirect to="/networks" />,
}: Props) {
  if (!permissions.network) {
    return <Redirect to="/catalog" />;
  }

  if (permissions.godMode && !currentNetworkId) {
    // ReactElement<any>: https://github.com/microsoft/TypeScript/pull/29818
    return handleGodModeAccess() as React.ReactElement<any>;
  }

  // ReactElement<any>: https://github.com/microsoft/TypeScript/pull/29818
  return children as React.ReactElement<any>;
}
